import { URLs } from '../config'
import http from './http'
import { objectToFormdata } from './common'

export const map = { 
    get: {
        // @Url /v1/common/{cbidx}/search-caregiver
        searchCaregiver: async (params) => {
            return await http.get(
                `/v1/common/${params.cbidx}/search-caregiver`,
                {
                    params: params
                }
            )
        },
        // @Url /v1/common/{cbidx}/search-senior
        searchSenior: async (params) => {
            return await http.get(
                `/v1/common/${params.cbidx}/search-senior`, {
                    params: params
                }
            )
        },
        // @Url /v1/common/{cbidx}/caregiver-schedule
        caregiverSchedule: async (params) => {
            return await http.get(
                `/v1/common/${params.cbidx}/caregiver-schedule`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/check-staff-state
        checkStaffState: async (params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/check-staff-state`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/search-memo
        searchMemo: async (params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/search-memo`, {
                    params: params
                }
            )
        },
        // @Url /v1/common/{cbidx}/profile
        profile: async (params) => {
            return await http.get(
                `/v1/common/${params.cbidx}/profile`, {
                    params: params
                }
            )
        },
        // @Url /v1/common/{cbidx}/search-senior-map
        searchSeniorMap: async (params) => {
            return await http.get(
                `/v1/common/${params.cbidx}/search-senior-map`, {
                    params: params
                }
            )
        }
    },
    post: {
        // @Url /v1/staffs/{cbidx}/search-memo
        searchMemo: async (params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/search-memo`, formData
            )
        },
        // @Url /v1/members/other-member
        otherMember: async (params) => {
            return await http.post(
                `${URLs.members}/other-member`, 
                params,
                {
                    params: {
                        luidx: params.luidx,
                        cbidx: params.cbidx,
                    }
                }
            )
        }
    },
    delete: {
        // @Url /v1/staffs/{cbidx}/search-memo
        searchMemo: async (params) => {
            return await http.delete(
                `${URLs.staffs}/${params.cbidx}/search-memo`, {
                    params: params
                }
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/api/map.js